import React from 'react';
import Link from 'next/link';
//
//
// Conditionally wrap the title and the image in a link
interface ConditionallyWrapWithUrlProps {
  href?: string | null;
  target?: boolean;
  children: React.ReactNode;
  dataTestId?: string;
}

const ConditionallyWrapWithUrl: React.FC<ConditionallyWrapWithUrlProps> = ({
  href,
  target,
  children,
  dataTestId,
}) => {
  return href ? (
    <Link data-testid={dataTestId} href={href} passHref target={target ? '_blank' : '_self'}>
      {children}
    </Link>
  ) : (
    <>{children}</>
  );
};

export default ConditionallyWrapWithUrl;
